<template>
<div class="wrapper">
<section class="top_banner" :style="{ 'background-image': 'url(' + imageBanner + ')' }">
  <wv-flex :gutter="0" class="banner_container banner_industry">
    <wv-flex-item>
      <div class="headline">全球客户案例</div>
      <div class="text">多行业，多容器的专业解决方案</div>
    </wv-flex-item>
  </wv-flex>
</section>
<section class="case-cate-nav">
  <div class="case-cate-nav-wrapper">
    <slick class="my-swipe" ref="slick" :options="slickOptions" @afterChange="handleAfterChange"  @beforeChange="handleBeforeChange">
      <div class="slide-item slide1" data-cate="all">
        <router-link :to="{ path: getRouteUrl('all')}">
          <span class="case-cate" data-cate="all">全部</span>
        </router-link>
      </div>
      <div class="slide-item slide2" data-cate="case01">
        <router-link :to="{ path: getRouteUrl('case01')}">
          <span class="case-cate" data-cate="case01">玻璃瓶</span>
        </router-link>
      </div>
      <div class="slide-item slide3" data-cate="case02">
        <router-link :to="{ path: getRouteUrl('case02')}">
          <span class="case-cate" data-cate="case02">PET瓶</span>
        </router-link>
      </div>
      <div class="slide-item slide4" data-cate="case03">
        <router-link :to="{ path: getRouteUrl('case03')}">
          <span class="case-cate" data-cate="case03">易拉罐</span>
        </router-link>
      </div>
    </slick>
  </div>
</section>
<section class="main-content case">
  <div class="loading-container el-hide">
    <div class="signal"></div>
  </div>
  <div class="case-list">
    <template v-for="(value, key) in itemdata.content">
      <template v-if="$route.params.category === value.id">
        <div class="case-item" :key="value.id + '-id-' + key + Date.parse(new Date())">
          <div class="img_container"><img :src="getImgUrl(value.image)" alt=""></div>
          <div class="text-wrapper">
            <div class="headline">{{ value.headline }}</div>
            <div class="info">{{ value.info }}</div>
          </div>
        </div>
      </template>
      <template v-else-if="$route.params.category === 'all'">
        <div class="case-item" :key="value.id  + '-all-' + key + Date.parse(new Date())">
          <div class="img_container"><img :src="getImgUrl(value.image)" alt=""></div>
          <div class="text-wrapper">
            <div class="headline">{{ value.headline }}</div>
            <div class="info">{{ value.info }}</div>
          </div>
        </div>
      </template>

    </template>
  </div>
</section>
</div>
</template>

<script>
import $ from 'jquery'
import database from '../../static/data/cases.json'

// import 'swiper/dist/css/swiper.css'
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'slick-carousel/slick/slick.css'
import Slick from 'vue-slick'

import axios from 'axios'
const caseUrl = './static/data/cases.json'

export default {
  name: 'CaseNewPage',
  components: {
    Slick
  },
  data () {
    return {
      itemdata: database,
      currentCate: 'all',
      currentCateObj: {'value33': 'all'},
      imageBanner: 'static/images/bg-banner-case.jpg',
      imageIcon01: 'static/images/1-1-icon.png',
      imageIcon02: 'static/images/1-2-icon.png',
      imageIcon03: 'static/images/1-3-icon.png',
      imageIcon04: 'static/images/1-4-icon.png',
      imageIcon05: 'static/images/1-5-icon.png',
      imageIcon06: 'static/images/1-6-icon.png',
      slickOptions: {
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        centerMode: true,
        // variableWidth: true,
        centerPadding: '60px'
        // Any other options that can be got from plugin documentation
      }
    }
  },
  mounted: function () {
    this.$nextTick(function () {
    })
  },
  watch: {
  },
  methods: {
    handleBeforeChange (event, slick, currentSlide, nextSlide) {
      // console.log('handleBeforeChange', event, slick, currentSlide, nextSlide)
      $('.loading-container').removeClass('el-hide')
      $('.case-list').addClass('el-hide')
    },
    handleAfterChange (event, slick, currentSlide) {
      // console.log('handleAfterChange', event, slick, currentSlide)
      axios.get(caseUrl, {
        params: {
          ID: 'khs'
        }
      }).then(function (response) {
        let allData = response.data['content']
        let slickTargetData = []
        let cate = $('.slick-current .slide-item').attr('data-cate')
        // console.log('start 123 -----')
        //
        // console.log('active: ' + cate)

        for (let i = 0; i < allData.length; i++) {
          if (cate === allData[i].id) {
            // console.log(allData[i])
            slickTargetData.push(allData[i])
            // slickTargetData[i].id = allData[i].id
            // slickTargetData[i].headline = allData[i].headline
            // slickTargetData[i].info = allData[i].info
          } else if (cate === 'all') {
            slickTargetData.push(allData[i])
          }
        }
        this.itemdata.content = slickTargetData

        $('.loading-container').addClass('el-hide')
        setTimeout(function () {
          $('.case-list').removeClass('el-hide')
        }, 100)
      }.bind(this)).catch(function (response) {
        console.log('error: ' + response)
      })

      // console.log(this.itemdata)
    },
    getRouteUrl: function (url) {
      return url
    },
    getImgUrl: function (img) {
      return 'static/images/' + img
    }
  },
  computed: {
  }
}
</script>

<style lang="scss">
  .el-hide {
    display: none;
  }
  .loading-container {
    height: 80px;
    position: relative;
  }
  .signal {
    border: 5px solid #333;
    border-radius: 30px;
    height: 30px;
    left: 50%;
    margin: -15px 0 0 -15px;
    opacity: 0;
    position: absolute;
    top: 75%;
    width: 30px;

    animation: pulsate 1s ease-out;
    animation-iteration-count: infinite;
  }

  @keyframes pulsate {
    0% {
      transform: scale(.1);
      opacity: 0.0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: scale(1.2);
      opacity: 0;
    }
  }

  .slick-slide {
    text-align: center;
  }

  .case-cate-nav {
    /*padding-left: 24px;*/
    /*padding-right: 24px;*/
    overflow: hidden;
    box-shadow: 2px 0px 3px 1px rgba(0, 0, 0, 0.2);
    user-select: none;
    /*border-bottom: 1px solid #e0e6ee;*/
    /*border-bottom: 1px solid blue;*/
    position: relative;
    z-index: 10;

    a {
      pointer-events: none;
      cursor: default;
      text-decoration: none;
    }

    .slick-current {
      .case-cate {
        /*border-bottom: 1px solid #0d3b6d;*/
        color: #0d3b6d;
        position: relative;
        &:after {
          content: "";
          display: inline-block;
          position: absolute;
          left: 0;
          right: 0;
          bottom: -1px;
          height: 2px;
          background: #0d3b6d;
          z-index: 100;
        }
      }
    }
    .case-cate {
      display: inline-block;
      padding: 10px 0 7px;
      color: #9eb1c5;
      font-size: 14px;
      user-select: none;
    }
  }

  .case-list {
    padding: 15px 0;

    .case-item {
      position: relative;
      margin: 15px 0;

      img {
        max-height: 563px;
      }

      .text-wrapper {
        padding: 10px 15px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.5);
        color: #ffffff;

        .headline {
          font-size: 12px;
        }

        .info {
          font-size: 14px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CaseNewPage.vue